<template>
  <v-card>
    <div class="password-checking security-card-content">
      <h2 class="check-password-title">
        {{ $i18n.t("passwordChecking.title") }}
      </h2>

      <p class="check-password-text">
        {{ $i18n.t("passwordChecking.text") }}
      </p>

      <div class="password-form">
        <v-text-field
          v-model="password"
          :type="showPassword ? 'text' : 'password'"
          :placeholder="$i18n.t('passwordChecking.placeholder')"
          outlined
          class="password-text-field"
          autocomplete="off"
          hide-details
        >
          <template v-slot:append v-if="password">
            <v-icon color="#333333" @click="showPassword = !showPassword">
              {{ showPassword ? "mdi-eye-outline" : "mdi-eye-off-outline" }}
            </v-icon>
          </template>
        </v-text-field>

        <div class="recover-password-text" @click="$emit('recoverPassword')">
          {{ $i18n.t("passwordChecking.recoverPassword") }}
        </div>

        <NewButton
          :text="$i18n.t('base.nextStep')"
          :disabled="password.length === 0"
          :loading="loading"
          @on-click="$emit('setPasswordAuthorization', password)"
        />
      </div>
      <div
        class="cancel-text"
        @click="
          $emit('closeDialog');
          password = '';
        "
      >
        Cancelar
      </div>
    </div>
  </v-card>
</template>

<script>
import NewButton from "@/components/shared/NewButton.vue";

export default {
  name: "PasswordChecking",

  data: () => ({
    password: "",
    showPassword: false,
  }),

  components: {
    NewButton,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.check-password-title {
  font-weight: 600;
  font-size: 22px;
  line-height: 160%;
  color: #333333;
  margin-bottom: 20px;
}

.check-password-text {
  font-weight: 500;
  font-size: 16px;
  line-height: 160%;
  color: #333333;
  margin-bottom: 40px;
}

.password-text-field {
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
}

.password-form {
  width: 100%;
}

.recover-password-text {
  text-align: right;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #646363;
  margin: 20px 0 40px 0;
  &:hover {
    cursor: pointer;
  }
}

.toast-container {
  display: flex;
  justify-content: center;
  margin: 40px 0;
}
</style>
